import React from 'react';


const TableSection = ({ title, columns, data }) => (
    <div className="my-6">
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <table className="w-full border border-black border-collapse">
        <thead>
          <tr className="bg-gray-200">
            {columns.map((col, idx) => (
              <th key={idx} className="border border-black px-4 py-2 text-left">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {columns.map((col, colIdx) => {
                const key = col.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
                const value = row[key];
                return (
                  <td key={colIdx} className="border border-black px-4 py-2 align-top">
                    {typeof value === "string" && value.endsWith(".pdf") ? (
                      <a href={value} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                        CLICK HERE
                      </a>
                    ) : (
                      value
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
  
  export default function PublicDisclosure() {
    return (

 
  
   

      <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg">
       <h1 className="text-2xl font-bold text-center mb-4">Mandatory Public Disclosure</h1>
    
        
  
        {/* Section A */}
        <TableSection
          title="A : GENERAL INFORMATION :"
          columns={["SL No.", "INFORMATION", "DETAILS"]}
          data={[
            { slno: 1, information: "NAME OF THE SCHOOL", details: "Jai Gurudev International School Call" },
            { slno: 2, information: "AFFILIATION NO.(IF APPLICABLE)", details: "1030177" },
            { slno: 3, information: "SCHOOL CODE (IF APPLICABLE)", details: "50155" },
            { slno: 4, information: "COMPLETE ADDRESS WITH PIN CODE", details: "Jai Gurudev Public School, Isha Nagar, Parasia Road, Partala, Chhindwara, Chhindwara (M.P.) 480001" },
            { slno: 5, information: "PRINCIPAL NAME", details: "Amiti Srinivasa Rao" },
            { slno: 6, information: "PRINCIPAL QUALIFICATION", details: "M.Sc. (Chemistry), B.Ed." },
            { slno: 7, information: "SCHOOL EMAIL ID", details: "info@JGIS.com" },
            { slno: 8, information: "CONTACT DETAILS (LANDLINE/MOBILE)", details: "+91 07162-222311" },
          ]}
        />
  
        {/* Section B */}
        <TableSection
        title="B : DOCUMENTS AND INFORMATION:"
        columns={["SL No.", "DOCUMENTS/INFORMATION", "LINKS OF UPLOADED DOCUMENTS ON SCHOOL'S WEBSITE"]}
        data={[
          { slno: 1, documentsinformation: "COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY", linksofuploadeddocumentsonschoolswebsite: "/documents/Affiliation_letter_2021-2026.pdf" },
          { slno: 2, documentsinformation: "COPIES OF NOC", linksofuploadeddocumentsonschoolswebsite: "/documents/NOC.pdf" },         
          { slno: 3, documentsinformation: "COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE", linksofuploadeddocumentsonschoolswebsite: "/documents/Society.pdf" },
          { slno: 4, documentsinformation: "COPY CERTIFICATE OF LAND", linksofuploadeddocumentsonschoolswebsite: "/documents/JGISLANDCER25.pdf" },
          { slno: 6, documentsinformation: "COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE", linksofuploadeddocumentsonschoolswebsite: "/documents/JGISBUILDINGCER.pdf" },
          { slno: 7, documentsinformation: "COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY", linksofuploadeddocumentsonschoolswebsite: "/documents/FIRE_NOC.pdf" },
          { slno: 9, documentsinformation: "COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES", linksofuploadeddocumentsonschoolswebsite: "/documents/JGISWATERCER.pdf" },
        ]}
      />
  
        <p className="text-sm italic my-4">
          NOTE: THE SCHOOLS NEED TO UPLOAD THE SELF ATTESTED COPIES OF ABOVE LISTED DOCUMENTS BY CHAIRMAN/MANAGER/SECRETARY AND PRINCIPAL. IN CASE, IT IS NOTICED AT LATER STAGE THAT UPLOADED DOCUMENTS ARE NOT GENUINE THEN SCHOOL SHALL BE LIABLE FOR ACTION AS PER NORMS.
        </p>
  
        {/* Section C */}
      <TableSection
        title="C : RESULT AND ACADEMICS :"
        columns={["SL No.", "DOCUMENTS/INFORMATION", "LINKS OF UPLOADED DOCUMENTS ON SCHOOL'S WEBSITE"]}
        data={[
          { slno: 1, documentsinformation: "FEE STRUCTURE OF THE SCHOOL", linksofuploadeddocumentsonschoolswebsite: "/documents/Fees-Structure-2025-26.pdf" },
          { slno: 2, documentsinformation: "ANNUAL ACADEMIC CALANDER", linksofuploadeddocumentsonschoolswebsite: "/documents/Academic_Calander.pdf" },
          { slno: 3, documentsinformation: "LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)", linksofuploadeddocumentsonschoolswebsite: "/documents/SMC.pdf" },
          { slno: 4, documentsinformation: "LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABLILITY", linksofuploadeddocumentsonschoolswebsite: "/documents/ThreeYearsResult.pdf" },
        ]}
      />

      {/* Section D */}
      <TableSection
        title="D : STAFF (TEACHING) :"
        columns={["SL No.", "INFORMATION", "DETAILS"]}
        data={[
          { slno: 1, information: "PRINCIPAL", details: "01" },
          { slno: 2, information: "VICE PRINCIPAL", details: "01" },
          { slno: 3, information: "TOTAL NO. OF TEACHERS", details: "112" },
          { slno: 4, information: "PGT", details: "25" },
          { slno: 5, information: "TGT", details: "47" },
          { slno: 6, information: "PRT", details: "40" },
          { slno: 7, information: "TEACHERS SECTION RATIO", details: "40 : 1.5" },
          { slno: 8, information: "DETAILS OF SPECIAL EDUCATOR", details: "1" },
          { slno: 9, information: "DETAILS OF COUNSELLOR AND WELNESS TEACHER", details: "1" },
        ]}
      />

      <TableSection
        title="RESULT CLASS: X"
        columns={["SL No.", "YEAR", "NO. OF REGISTERED STUDENTS", "NO. OF STUDENTS PASSED", "PASS PERCENTAGE", "REMARKS"]}
        data={[
          { slno: 1, year: "2020-21", noofregisteredstudents: "285", noofstudentspassed: "285", passpercentage: "100", remarks: "" },
          { slno: 2, year: "2019-20", noofregisteredstudents: "263", noofstudentspassed: "251", passpercentage: "95.44", remarks: "" },
          { slno: 3, year: "2018-19", noofregisteredstudents: "236", noofstudentspassed: "231", passpercentage: "97.88", remarks: "" },
        ]}
      />

      <TableSection
        title="RESULT CLASS: XII"
        columns={["SL No.", "YEAR", "NO. OF REGISTERED STUDENTS", "NO. OF STUDENTS PASSED", "PASS PERCENTAGE", "REMARKS"]}
        data={[
          { slno: 1, year: "2020-21", noofregisteredstudents: "193", noofstudentspassed: "193", passpercentage: "100", remarks: "-" },
          { slno: 2, year: "2019-20", noofregisteredstudents: "174", noofstudentspassed: "153", passpercentage: "87.93", remarks: "-" },
          { slno: 3, year: "2018-19", noofregisteredstudents: "181", noofstudentspassed: "144", passpercentage: "79.56", remarks: "-" },
        ]}
      />

      {/* Section E */}
      <TableSection
        title="E : SCHOOL INFRASTRUCTURE:"
        columns={["SL No.", "INFORMATION", "DETAILS"]}
        data={[
          { slno: 1, information: "TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)", details: "12030 sq m" },
          { slno: 2, information: "NO. AND SIZE OF THE CLASS ROOMS (IN SQ FTMTR)", details: "115 & 633" },
          { slno: 3, information: "NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQ MTR)", details: "6 & 1055" },
          { slno: 4, information: "INTERNET FACILITY", details: "YES" },
          { slno: 5, information: "NO. OF GIRLS TOILETS", details: "10" },
          { slno: 6, information: "NO. OF BOYS TOILETS", details: "10" },
          { slno: 7, information: "LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL", details: "" },
        ]}
      />
    </div>
  );
}